module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "SubscriptionWrap"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "paymentModal loading"
  }, [_c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "modal"
  }, [(!_vm.isPaymentCancelled && !_vm.hasPaymentProcessed) ? _c('div', {
    staticClass: "block payment"
  }, [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "55",
      "tablet": "55",
      "width": "100"
    }
  }, [_c('div', {
    staticClass: "choose-plan"
  }, [_c('h2', [_vm._v("Choose your plan")]), _vm._v(" "), _c('p', [_vm._v("Get access to the world's largest low carb community, multi-award winning education, daily meal plans,\n              recipes and more!")]), _vm._v(" "), _c('div', {
    staticClass: "discount-code"
  }, [_c('h3', [_vm._v("Got a discount code?")]), _vm._v(" "), _c('p', [_vm._v("Choose your plan, then enter your code at checkout.")])]), _vm._v(" "), (_vm.discountData) ? _c('div', {
    staticClass: "payment-plans"
  }, [_vm._l((_vm.prices), function(price, index) {
    return _c('div', [_c('div', {
      key: ("price-" + index),
      staticClass: "subscription",
      class: {
        'yearly': price.description === 'Yearly',
        'monthly': price.description !== 'Yearly'
      },
      on: {
        "click": function($event) {
          return _vm.createStripeSession(price)
        }
      }
    }, [_c('div', {
      staticClass: "overlay",
      nativeOn: {
        "click": function($event) {
          return _vm.createStripeSession(price)
        }
      }
    }, [_c('mu-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!price.selected),
        expression: "!price.selected"
      }],
      staticClass: "radio unchecked",
      attrs: {
        "value": "radio_button_unchecked"
      }
    }), _vm._v(" "), _c('mu-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (price.selected),
        expression: "price.selected"
      }],
      staticClass: "radio checked",
      attrs: {
        "value": "radio_button_checked"
      }
    }), _vm._v(" "), _c('strong', {
      staticClass: "itemName",
      domProps: {
        "textContent": _vm._s(price.description)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "itemPrice"
    }, [_vm._v("\n                " + _vm._s(price.amount) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "itemDesc",
      domProps: {
        "innerHTML": _vm._s(price.extra ? price.extra : price.extra_description)
      }
    }), _vm._v(" "), (price.percentageOffForCurrentUser > 0) ? _c('div', {
      staticClass: "discount"
    }, [_c('span', [_vm._v("Save " + _vm._s(price.percentageOffForCurrentUser) + "%")])]) : _vm._e()], 1)])])
  }), _vm._v(" "), _c('stripe-checkout', {
    ref: "sessionCheckoutRef",
    attrs: {
      "pk": _vm.publishableKey,
      "session-id": _vm.sessionId
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "terms"
  }, [_c('p', [_vm._v("Recurring billing, cancel anytime.")]), _vm._v(" "), _c('p', [_vm._v("By continuing, you accept our "), _c('a', {
    attrs: {
      "href": _vm.Config('siteUrl') + 'terms',
      "target": "_blank"
    }
  }, [_vm._v("Terms and\n                Conditions")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": _vm.Config('siteUrl') + 'privacy',
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": _vm.Config('siteUrl') + 'billing-terms',
      "target": "_blank"
    }
  }, [_vm._v("Billing Terms")])]), _vm._v(" "), (_vm.selectedPackage) ? _c('div', {
    staticClass: "processing"
  }, [_c('p', [_vm._v("Processing...")])]) : _vm._e()])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "45",
      "tablet": "45",
      "width": "100"
    }
  }, [_c('h2', {
    staticClass: "whySub"
  }, [_vm._v("Why subscribe?")]), _vm._v(" "), _c('div', {
    staticClass: "benefits"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Award-winning, proven education on how to embrace a low carb lifestyle")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Practical Action Points to achieve your health goals")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Daily meal plans for 12 weeks to start and sustain your journey")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Over 1,800 searchable recipes and meal plans tailored to your preferences")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Group and one-to-one virtual meetups with expert coaches")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Peer support from " + _vm._s(_vm.numeral(_vm.stats.count).format('0,0')) + " members")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Integrated food diary with food search and barcode scanner")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Integrated health tracking and data exporting")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Daily updated news, research and guidance")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Access on the web, iOS, Android and Alexa")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Sync your data with Apple Health, Google Fit and FitBit")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Regularly updated features and enhancements")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Access on Apple Watch and Android Watch")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("check")]), _vm._v("Friendly technical support")])])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isPaymentCancelled) ? _c('div', {
    staticClass: "block cancelled"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('message.paywallPaywallFailed')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallPaywallFailedExplain')))]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "label": "Try again"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Subscription')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPaymentProcessed) ? _c('div', {
    staticClass: "block success"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Package")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.getParam('item_name')) + "\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Subscription ID")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.getParam('subscr_id')) + "\n          ")])]), _vm._v(" "), (_vm.getParam('trialbillingperiod')) ? _c('tr', [_c('td', [_vm._v("\n            Trial period\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getParam('trialbillingperiod')))])]) : _vm._e(), _vm._v(" "), (_vm.getParam('trialamt')) ? _c('tr', [_c('td', [_vm._v("Trial price")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getParam('trialamt')) + " " + _vm._s(_vm.getParam('cc')))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Price")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getParam('amt')) + " " + _vm._s(_vm.getParam('cc')))])])])]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "label": "Get started",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.continueProgram()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "titleLink"
  }, [_c('router-link', {
    attrs: {
      "to": '/register/amend'
    }
  }, [_vm._v("Need to update your details?\n      ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "modal"
  }, [_c('h2', [_vm._v("Been referred by your healthcare team?")]), _vm._v(" "), _c('p', [_vm._v("Enter your referral code below to access the Low Carb Program.")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "voucherForm",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.processVoucher.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "voucher"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "tablet": "70",
      "desktop": "70",
      "width": "70"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "id": "voucherTxt",
      "hintText": "Referral code (this is different from a discount code)",
      "fullWidth": "",
      "min": 20
    },
    model: {
      value: (_vm.voucher.code),
      callback: function($$v) {
        _vm.$set(_vm.voucher, "code", $$v)
      },
      expression: "voucher.code"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30",
      "width": "30"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "apply",
    attrs: {
      "id": "submitBtn",
      "type": "button",
      "label": "Check code",
      "disabled": (_vm.voucher.code.length <= 3) || _vm.voucher.isSending,
      "color": "#FFF",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processVoucher.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "message",
    class: {
      error: _vm.voucher.error === true,
      success: _vm.voucher.error === false
    },
    domProps: {
      "textContent": _vm._s(_vm.voucher.isSending ? 'Processing...' : _vm.voucher.message)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "discount-text"
  }, [_vm._v("Got a discount code? Select a plan above and enter it at checkout")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c93e5c6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubscriptionForm/SubscriptionForm.vue
// module id = 3814
// module chunks = 1